import { Box, Typography } from '@mui/material';

import forbiddenAccessImage from '@/assets/undergoing-maintenance-illustration.png';

interface MaintenanceScreenProps {
  message?: string;
}

export default function MaintenanceScreen({
  message = 'Site is undergoing maintenance',
}: MaintenanceScreenProps) {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: (theme) => theme.palette.background.default,
        zIndex: 9999,
        overflow: 'hidden',
        p: 2,
      }}
    >
      <Box
        component="img"
        src={forbiddenAccessImage}
        sx={{
          maxWidth: '100%',
          maxHeight: { xs: '45%', sm: '50%', md: '60%' },
          objectFit: 'contain',
          mb: { xs: 3, md: 4 },
        }}
        alt="Maintenance"
      />
      <Typography
        variant="h1"
        textAlign="center"
        sx={{
          fontWeight: 'bold',
          mb: { xs: 1, md: 2 },
          wordBreak: 'break-word',
        }}
      >
        Portal is under maintenance
      </Typography>
      <Typography
        variant="h4"
        textAlign="center"
        sx={{
          wordBreak: 'break-word',
        }}
      >
        {message}
      </Typography>
    </Box>
  );
}
